import { render } from "./NavigatorComponent.vue?vue&type=template&id=b8f531fa&scoped=true&ts=true"
import script from "./NavigatorComponent.ts?vue&type=script&lang=ts"
export * from "./NavigatorComponent.ts?vue&type=script&lang=ts"

import "./NavigatorComponent.scss?vue&type=style&index=0&id=b8f531fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f531fa"]])

export default __exports__